import { Box, Grid, Button, IconButton } from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import { Check, Delete } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import Alert from "@mui/lab/Alert";
import { MaxReceipt, MaxFileSize } from "../../../Constant";
import { MyButton } from "../../../components/my-button/MyButton";
import { MyTextField } from "../../../components/my-text-field/MyTextField";
import MyContext from "../../../contexts/MyContext";
import AttachFile from "@mui/icons-material/AttachFile";

export const AddReceipt = (props) => {
  const myContext = useContext(MyContext);
  const { t } = useTranslation();
  const [receipt, setReceipt] = useState(props.receipt);
  const [totalCost, setTotalCost] = useState(props.totalCost);
  const [error, setError] = useState(null);
  const hiddenFileInput = React.useRef(null);

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const removeReceipt = (fileName) => {
    setReceipt(receipt.filter((item) => item.name !== fileName));
  };

  const handleSave = () => {
    if (totalCost && (!receipt || receipt.length === 0)) setError("receipt_required");
    else if (!totalCost && receipt && receipt.length > 0) setError("total_cost_required");
    else {
      props.onSave(receipt, totalCost);
    }
  };

  const handleChangeTotalCost = (value) => {
    //if (Number(value) > Number(myContext.totalCostSEKMax)) setTotalCost(totalCost.toString());
    //else setTotalCost(value);
    setTotalCost(value);
  };

  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    if (myContext.allowFileUploadExtension.find((extension) => fileUploaded.name.toLowerCase().endsWith(extension.toLowerCase())) == null)
      setError("not_allowed");
    else if (fileUploaded.size > MaxFileSize) setError("your_uploaded_file_too_big");
    else {
      setReceipt((oldArray) => [...oldArray.filter((item) => item.name !== fileUploaded.name), fileUploaded]);
      setError(null);
      hiddenFileInput.current.value = "";
    }
  };

  useEffect(() => {
    if (!props.open) setError(null);
  }, [props.open]);

  return (
    <MyContext.Consumer>
      {(context) => (
        <>
          {error && (
            <Alert variant="filled" severity="error" className="margin top-1 bottom-1">
              {t(error)}
            </Alert>
          )}
          {(!receipt || receipt.length > 0) && (
            <>
              <hr className="margin top-0 bottom-0" aria-hidden={true} />
              {receipt.map((item, key) => (
                <Grid container key={key} justifyContent="space-between" alignItems={"center"}>
                  <Grid xs={10} sm={10} color="primary.main" item container wrap="nowrap" alignItems={"center"} style={{ overflowX: "hidden" }}>
                    <AttachFile fontSize="small" color="primary.main" style={{ marginRight: "1rem", marginLeft: "0.5rem" }} />
                    <Box whiteSpace={"nowrap"} component="small" color="primary.main">
                      {item.name}
                    </Box>
                  </Grid>
                  <Grid item>
                    <IconButton aria-label={t("delete")} onClick={(e) => removeReceipt(item.name)}>
                      <Delete />
                    </IconButton>
                  </Grid>
                </Grid>
              ))}
            </>
          )}
          {(!receipt || receipt.length < (props.maxReceipt ? props.maxReceipt : MaxReceipt)) && (
            <>
              <hr className="margin top-0 bottom-0" aria-hidden={true} />
              <Button
                aria-haspopup="dialog"
                variant="text"
                className="button secondary w-100 justify-content-start"
                style={{
                  textTransform: "unset",
                }}
                onClick={handleClick}
              >
                <AttachFile fontSize="small" color="primary.main" style={{ marginRight: "1rem" }} />
                <span>{t("add_image_of_receipt")}</span>
              </Button>
              <input
                accept={context.allowFileUploadExtension.map((extension) => `.${extension}`.toLowerCase()).join()}
                type="file"
                ref={hiddenFileInput}
                onChange={handleChange}
                style={{ display: "none" }}
              />
            </>
          )}
          <hr className="margin top-0 bottom-0" aria-hidden={true} />
          <MyTextField
            regExp={"^[0-9]*$"}
            type="text"
            inputMode="numeric"
            //max={context.totalCostSEKMax}
            value={totalCost}
            label={t("total_cost")}
            onChange={handleChangeTotalCost}
          />
          <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2}>
            <Grid item>
              <MyButton className="button primary" onClick={props.onClose} color="default" text={t("back")} buttonVariant="outlined" />
            </Grid>
            <Grid item>
              <MyButton className="button primary" text={t("save_and_close")} onClick={handleSave} />
            </Grid>
          </Grid>
        </>
      )}
    </MyContext.Consumer>
  );
};
